"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Catalan
var strings = {
  prefixAgo: 'fa',
  prefixFromNow: "d’aqui",
  suffixAgo: null,
  suffixFromNow: null,
  seconds: "mens d'1 minuta",
  minute: '1 minuta',
  minutes: 'unas %d minutas',
  hour: '1 ora',
  hours: 'unas %d oras',
  day: '1 jorn',
  days: '%d jorns',
  month: 'aproximativament un mes',
  months: '%d meses',
  year: 'aproximativament un an',
  years: '%d ans'
};
var _default = strings;
exports["default"] = _default;